import { lazy } from "react";

export const siteauditRoutes = [
  {
    path: "/siteaudit/dashboard",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditDashboardPage")),
    requiresAuth: true,
    meta: {
      title: "Site Audit Dashboard",
      description: "Complete SEO analysis dashboard with module summaries"
    }
  },
  {
    path: "/siteaudit/operations",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditOperationsPage")),
    requiresAuth: true,
    meta: {
      title: "Operations",
      description: "Manage your websites and monitor their SEO analysis status"
    }
  },
  {
    path: "/siteaudit/main-elements",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditMainElementsPage")),
    requiresAuth: true,
    meta: {
      title: "Main SEO Elements",
      description: "Essential SEO elements analysis"
    }
  },
  {
    path: "/siteaudit/open-graph",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditOpenGraphPage")),
    requiresAuth: true,
    meta: {
      title: "Open Graph Metadata",
      description: "Social media sharing optimization"
    }
  },
  {
    path: "/siteaudit/pixels-tags",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditPixelsTagsPage")),
    requiresAuth: true,
    meta: {
      title: "Pixels & Tags",
      description: "Analytics and tracking setup"
    }
  },
  {
    path: "/siteaudit/marktech",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditMarktechPage")),
    requiresAuth: true,
    meta: {
      title: "Marktech Analysis",
      description: "Marketing technology stack"
    }
  },
  {
    path: "/siteaudit/speed-performance",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditSpeedPerformancePage")),
    requiresAuth: true,
    meta: {
      title: "Speed Performance",
      description: "Loading speed and performance"
    }
  },
  {
    path: "/siteaudit/mobile-analysis",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditMobileAnalysisPage")),
    requiresAuth: true,
    meta: {
      title: "Mobile Analysis",
      description: "Mobile optimization and usability"
    }
  },
  {
    path: "/siteaudit/expert-validation",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditExpertValidationPage")),
    requiresAuth: true,
    meta: {
      title: "Expert Validation",
      description: "Review and validate automated scores for all modules"
    }
  },
  {
    path: "/siteaudit/webhook-settings",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditWebhookSettingsPage")),
    requiresAuth: true,
    meta: {
      title: "Webhook Settings",
      description: "Configure webhook URLs for notifications"
    }
  },
  {
    path: "/siteaudit/client/:shareCode",
    component: lazy(() => import("@/pages/SiteAudit/SiteAuditPortalAuthPage")),
    requiresAuth: false,
    meta: {
      title: "Access Audit Report",
      description: "Enter PIN to access your audit report"
    }
  },
  {
    path: "/siteaudit/client/:shareCode/view",
    component: lazy(() => import("@/pages/siteaudit/SiteAuditClientPage")),
    requiresAuth: false,
    meta: {
      title: "Website Audit Report",
      description: "View your website audit results"
    }
  }
];

